import React from 'react'
import PropTypes from 'prop-types'

import Checkbox from '../Checkbox/newCheckbox'
import ExclusionModal from '../ExclusionModal/ExclusionModal'

import Glyph from 'component/utils/Glyph'

import chevronDown from 'images/chevron-down.svg'

const EMPTY = '-'

const Table = ({
  handleResize,
  lsDsProfiles,
  openEditModal,
  openRemoveModal,
  openViewModal,
  records,
  setLsDsProfiles,
  translate,
  onOrderChange,
  orderBy,
  handleProfileDeletion,
}) => {
  const lsDsProfilesLength = lsDsProfiles.length

  const renderHeader = () => {
    let setAll = true
    let checked = false
    let partialChecked = false

    if (lsDsProfilesLength) {
      checked = true
      if (lsDsProfilesLength === records.length) {
        setAll = false
      } else {
        partialChecked = true
      }
    }

    return (
      <tr>
        <th className='text-align-center'>
          <Checkbox
            label={''}
            className={partialChecked ? 'square-check' : ''}
            name={'selectall'}
            checked={checked}
            onChange={() => {
              setLsDsProfiles(setAll ? records : [])
            }}
          />
        </th>
        <th onClick={onOrderChange} className='cursor-pointer'>
          {translate('missionMenu.table.header.profileName')}&nbsp;&nbsp;
          <img
            className={`order-by-chevron ${orderBy && 'invert-chevron'}`}
            src={chevronDown}
          />
        </th>
        <th>{translate('missionMenu.table.header.ldap')}</th>
        <th>{translate('missionMenu.table.header.registerType')}</th>
        <th className='text-align-center'>
          {!lsDsProfilesLength &&
            translate('missionMenu.table.header.permissions')}
        </th>
        <th className='text-align-center'>
          {!lsDsProfilesLength && translate('edit_button_label')}
        </th>
        <th className='text-align-center'>
          {!lsDsProfilesLength && translate('exclude_button')}
        </th>
      </tr>
    )
  }

  const renderBody = () => {
    handleResize()

    const renderRecord = (record, index) => {
      const dsProfile =
        record.dsProfile + (record.dsLdap ? record.dsLdap : record.cdMission)

      const checked = lsDsProfiles.some(
        (item) =>
          item.dsProfile + (item.dsLdap ? item.dsLdap : item.cdMission) ===
          dsProfile
      )

      return (
        <tr key={dsProfile} className={checked ? 'row-checked' : ''}>
          <td className='text-align-center'>
            <Checkbox
              label={''}
              name={`selectitem${index}`}
              checked={checked}
              onChange={() => {
                setLsDsProfiles(
                  checked
                    ? lsDsProfiles.filter(
                        (i) =>
                          i.dsProfile + (i.dsLdap ? i.dsLdap : i.cdMission) !==
                          dsProfile
                      )
                    : [...lsDsProfiles, record]
                )
              }}
            />
          </td>
          <td>{record.cdMission ? record.dsMission : record.dsProfile}</td>
          <td>{record.dsLdap || EMPTY}</td>
          <td>
            {translate(
              record.cdMission
                ? 'missionMenu.table.mission'
                : 'missionMenu.table.personalProfile'
            )}
          </td>
          <td
            onClick={() => (!lsDsProfilesLength ? openViewModal(record) : {})}
            className='mission-block-edit-icon'
          >
            {!lsDsProfilesLength && <Glyph type='eye' color='primary' />}
          </td>
          <td
            onClick={() => (!lsDsProfilesLength ? openEditModal(record) : {})}
            className='mission-block-edit-icon'
          >
            {!lsDsProfilesLength && <Glyph type='pencil' color='primary' />}
          </td>
          <td
            onClick={() => (!lsDsProfilesLength ? openRemoveModal(record) : {})}
            className='mission-block-edit-icon'
          >
            {!lsDsProfilesLength && (
              <ExclusionModal
                t={translate}
                title={translate('punctual.adj.approvers.remove.perm')}
                message={
                  <>
                    <br />
                    {translate('missionMenu.removeModal.text')}
                    <br />
                    <b> {record.dsProfile} </b>
                  </>
                }
                confirmButtonMsg='approvers.remove.confirm'
                onConfirm={() => {
                  handleProfileDeletion(record)
                }}
                renderButton={({ onClick }) => (
                  <a
                    className='trash-icon-padding'
                    id={`view-mission-${index}`}
                    role='button'
                    onClick={onClick}
                  >
                    <i className='color-danger glyph glyph-trash-can icon-size' />
                  </a>
                )}
              />
            )}
          </td>
        </tr>
      )
    }

    return records.map(renderRecord)
  }

  return (
    <table cellPadding={0} cellSpacing={0} className='new-table'>
      <thead>{renderHeader()}</thead>
      <tbody>{renderBody()}</tbody>
    </table>
  )
}

Table.propTypes = {
  handleResize: PropTypes.func.isRequired,
  lsDsProfiles: PropTypes.array.isRequired,
  openEditModal: PropTypes.func.isRequired,
  openRemoveModal: PropTypes.func.isRequired,
  openViewModal: PropTypes.func.isRequired,
  records: PropTypes.array.isRequired,
  setLsDsProfiles: PropTypes.func.isRequired,
  translate: PropTypes.func.isRequired,
  onOrderChange: PropTypes.func,
  orderBy: PropTypes.bool,
  handleProfileDeletion: PropTypes.func,
}

export default Table
